import React from "react";
import { Link } from "react-router-dom";
import MainLogo from "../brand/MainLogo";
import RonaWalkLogo from "../brand/RonaWalkLogo";
import GoldenPathLogo from "../brand/GoldenPathLogo";
import MicroIcon from "../brand/MicroIcon";
import { COLORS, PILLARS, BRAND_TAGLINE, SITE, SEASONS, STORY_WELLNESS } from "../brand/tokens";

const HomePage = () => (
  <main className="site-main" data-testid="page-home">
    {/* HERO */}
    <section className="home-hero">
      <div className="home-hero__grain" aria-hidden />
      <div className="home-hero__inner">
        <div className="home-hero__text">
          <p className="eyebrow">RONA WELLNESS · LUXURY LIFESTYLE BRAND</p>
          <h1 className="home-hero__h1">
            Take one <em>gentle</em><br />step.
          </h1>
          <p className="home-hero__sub">
            {BRAND_TAGLINE}. A luxury lifestyle brand — walking for wellness. Faith · Strength · Hope.
          </p>
          <div className="home-hero__cta">
            <a href={SITE.shops.etsy} target="_blank" rel="noreferrer" className="btn btn--gold" data-testid="hero-shop-etsy">Shop on Etsy</a>
            <Link to="/walk" className="btn btn--ghost" data-testid="hero-walk-link">The Rona Walk →</Link>
          </div>
          <p className="home-hero__pillars">{PILLARS}</p>
        </div>
        <div className="home-hero__logoframe">
          <MainLogo size={520} />
        </div>
      </div>
    </section>

    {/* STORY TEASER */}
    <section className="home-story">
      <div className="home-story__inner">
        <div className="home-story__text">
          <p className="eyebrow">OUR STORY</p>
          <h2>Healing does not always begin with dramatic change.</h2>
          <p className="lede">{STORY_WELLNESS.lines[1]}</p>
          <Link to="/about" className="btn btn--ghost" data-testid="home-story-link">Read our story →</Link>
        </div>
        <div className="home-story__logo">
          <GoldenPathLogo size={420} showTagline withFrame={false} />
        </div>
      </div>
    </section>

    {/* SEASONS PREVIEW */}
    <section className="home-seasons">
      <div className="section__head">
        <p className="eyebrow">THE RONA WALK · SEASONS</p>
        <h2>A walk for every season of the soul.</h2>
        <p className="lede">The Rona Walk is represented through five seasonal themes — one tree, five seasons, five voices.</p>
      </div>
      <div className="home-seasons__grid">
        {SEASONS.map((s) => (
          <Link to={`/walk#${s.id}`} key={s.id} className="home-season-card" data-testid={`home-season-${s.id}`}>
            <div className="home-season-card__accent" style={{ background: s.accent }} />
            <div className="home-season-card__body">
              <p className="eyebrow">{s.theme.toUpperCase()}</p>
              <h3>{s.name}</h3>
              <p>{s.title}</p>
              <span className="home-season-card__hashtag">{s.hashtag}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>

    {/* CTA STRIP */}
    <section className="home-cta">
      <MicroIcon size={60} color={COLORS.gold} />
      <h2>Where movement meets peace.</h2>
      <p>Join the walk. Monthly reflections and seasonal stories from Rona Wellness.</p>
      <div className="home-cta__buttons">
        <a href={SITE.shops.etsy} target="_blank" rel="noreferrer" className="btn btn--gold" data-testid="home-cta-etsy">Shop the collection</a>
        <Link to="/contact" className="btn btn--ghost" data-testid="home-cta-contact">Say hello →</Link>
      </div>
    </section>
  </main>
);

export default HomePage;
